<template>
<div class="await-loading">
  <mt-spinner class="loading-icon" :type="type"  color="#00B097" slot="value"></mt-spinner>
</div>
</template>
<script>
import { Spinner } from 'mint-ui'
export default {
  data() {
    return {
      type: 'snake'
    }
  },
  components: { Spinner }
}
</script>
<style scoped lang="less">
.await-loading{
  text-align: center;
  padding: 1rem 0 0 0;
  margin: .59rem auto;
  .loading-icon{
    display: inline-block;
  }
}
</style>
